import * as React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import { Stack, Tabs, Typography, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { fDateTime } from 'src/utils/format-time';

const useStyles = makeStyles(theme => ({
  timeLineName: {
    fontWeight: 600,
  },
  timeLineDate: {
    fontSize: '10px',
    color: theme.palette.content.primaryBlack3,
  },
}));

export default function TrackingTimeline({ data }) {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <Timeline
      sx={{
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 0,
        },
        marginTop: '4px',
      }}
    >
      {/* <Tabs
                orientation="vertical"
                variant="scrollable"> */}
      {data.map((item, index) => (
        <TimelineItem key={index}>
          <TimelineSeparator>
            <TimelineDot
              sx={{ bgcolor: theme.palette.background.primaryAccent1 }}
            />
            {index !== data.length - 1 && (
              <TimelineConnector
                sx={{ bgcolor: theme.palette.background.primaryAccent1 }}
              />
            )}
          </TimelineSeparator>
          <TimelineContent>
            <Stack direction="column" spacing="4px">
              <Typography variant="input" className={classes.timeLineName}>
                {item.event_name}
              </Typography>
              <Typography variant="caption" className={classes.timeLineDate}>
                {fDateTime(item.event_time)}
              </Typography>
            </Stack>
          </TimelineContent>
        </TimelineItem>
      ))}
      {/* </Tabs> */}
    </Timeline>
  );
}
